module.exports = __webpack_public_path__ + "static/img/c2.7c51a70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c2.jpg
// module id = jCu3
// module chunks = 1